import { render, staticRenderFns } from "./VehicleView.vue?vue&type=template&id=4aa9f251&"
import script from "./VehicleView.vue?vue&type=script&lang=js&"
export * from "./VehicleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports